import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import index from '../components/index.vue'
import login from '../components/login.vue'
import register from '../components/register.vue'
import callWay from '../components/call_way.vue'
import serve from '../components/serve.vue'
import pufa from '../components/pufa.vue'

const routes = [
  {
    path:'/',
    redirect:'index'
  },
  //首页
  {
    path:'/index',
    name:'index',
    component:index,
  },
  //登录页
  {
    path:'/login',
    name:'login',
    component:login
  },
  //注册
  {
    path:'/register',
    name:'register',
    component:register
  },
  //联系我们
  {
    path:'/callWay',
    name:'callWay',
    component:callWay
  },
  //服务条款
  {
    path:'/serve',
    name:'serve',
    component:serve
  },
  //普法宣传
  {
    path:'/pufa',
    name:'pufa',
    component:pufa
  }
]

export default new Router({
  routes,
  mode:'hash'
})